import { render } from "./SurveyView.vue?vue&type=template&id=677705e8&scoped=true"
import script from "./SurveyView.vue?vue&type=script&lang=js"
export * from "./SurveyView.vue?vue&type=script&lang=js"

import "./SurveyView.vue?vue&type=style&index=0&id=677705e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677705e8"]])

export default __exports__